/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum StateCode {
  AL = "AL",
  AK = "AK",
  AZ = "AZ",
  AR = "AR",
  CA = "CA",
  CO = "CO",
  CT = "CT",
  DE = "DE",
  DC = "DC",
  FL = "FL",
  GA = "GA",
  HI = "HI",
  ID = "ID",
  IL = "IL",
  IN = "IN",
  IA = "IA",
  KS = "KS",
  KY = "KY",
  LA = "LA",
  ME = "ME",
  MD = "MD",
  MA = "MA",
  MI = "MI",
  MN = "MN",
  MS = "MS",
  MO = "MO",
  MT = "MT",
  NE = "NE",
  NV = "NV",
  NH = "NH",
  NJ = "NJ",
  NM = "NM",
  NY = "NY",
  NC = "NC",
  ND = "ND",
  OH = "OH",
  OK = "OK",
  OR = "OR",
  PA = "PA",
  RI = "RI",
  SC = "SC",
  SD = "SD",
  TN = "TN",
  TX = "TX",
  UT = "UT",
  VT = "VT",
  VA = "VA",
  WA = "WA",
  WV = "WV",
  WI = "WI",
  WY = "WY",
}

export const StateCodeDisplay: Record<StateCode, string> = {
  [StateCode.AL]: "Alabama",
  [StateCode.AK]: "Alaska",
  [StateCode.AZ]: "Arizona",
  [StateCode.AR]: "Arkansas",
  [StateCode.CA]: "California",
  [StateCode.CO]: "Colorado",
  [StateCode.CT]: "Connecticut",
  [StateCode.DE]: "Delaware",
  [StateCode.DC]: "District Of Columbia",
  [StateCode.FL]: "Florida",
  [StateCode.GA]: "Georgia",
  [StateCode.HI]: "Hawaii",
  [StateCode.ID]: "Idaho",
  [StateCode.IL]: "Illinois",
  [StateCode.IN]: "Indiana",
  [StateCode.IA]: "Iowa",
  [StateCode.KS]: "Kansas",
  [StateCode.KY]: "Kentucky",
  [StateCode.LA]: "Louisiana",
  [StateCode.ME]: "Maine",
  [StateCode.MD]: "Maryland",
  [StateCode.MA]: "Massachusetts",
  [StateCode.MI]: "Michigan",
  [StateCode.MN]: "Minnesota",
  [StateCode.MS]: "Mississippi",
  [StateCode.MO]: "Missouri",
  [StateCode.MT]: "Montana",
  [StateCode.NE]: "Nebraska",
  [StateCode.NV]: "Nevada",
  [StateCode.NH]: "New Hampshire",
  [StateCode.NJ]: "New Jersey",
  [StateCode.NM]: "New Mexico",
  [StateCode.NY]: "New York",
  [StateCode.NC]: "North Carolina",
  [StateCode.ND]: "North Dakota",
  [StateCode.OH]: "Ohio",
  [StateCode.OK]: "Oklahoma",
  [StateCode.OR]: "Oregon",
  [StateCode.PA]: "Pennsylvania",
  [StateCode.RI]: "Rhode Island",
  [StateCode.SC]: "South Carolina",
  [StateCode.SD]: "South Dakota",
  [StateCode.TN]: "Tennessee",
  [StateCode.TX]: "Texas",
  [StateCode.UT]: "Utah",
  [StateCode.VT]: "Vermont",
  [StateCode.VA]: "Virginia",
  [StateCode.WA]: "Washington",
  [StateCode.WV]: "West Virginia",
  [StateCode.WI]: "Wisconsin",
  [StateCode.WY]: "Wyoming",
};
